/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as dom from 'vs/base/browser/dom';
import { IKeyboardEvent, StandardKeyboardEvent } from 'vs/base/browser/keyboardEvent';
import { IMouseEvent, StandardMouseEvent } from 'vs/base/browser/mouseEvent';
import { Gesture } from 'vs/base/browser/touch';
import { Disposable, IDisposable } from 'vs/base/common/lifecycle';

export abstract class Widget extends Disposable {

	protected c(domNode: HTMLElement, listener: (e: IMouseEvent) => void): void {
		this.q(dom.addDisposableListener(domNode, dom.EventType.CLICK, (e: MouseEvent) => listener(new StandardMouseEvent(e))));
	}

	protected j(domNode: HTMLElement, listener: (e: IMouseEvent) => void): void {
		this.q(dom.addDisposableListener(domNode, dom.EventType.MOUSE_DOWN, (e: MouseEvent) => listener(new StandardMouseEvent(e))));
	}

	protected k(domNode: HTMLElement, listener: (e: IMouseEvent) => void): void {
		this.q(dom.addDisposableListener(domNode, dom.EventType.MOUSE_OVER, (e: MouseEvent) => listener(new StandardMouseEvent(e))));
	}

	protected m(domNode: HTMLElement, listener: (e: IMouseEvent) => void): void {
		this.q(dom.addDisposableListener(domNode, dom.EventType.MOUSE_LEAVE, (e: MouseEvent) => listener(new StandardMouseEvent(e))));
	}

	protected n(domNode: HTMLElement, listener: (e: IKeyboardEvent) => void): void {
		this.q(dom.addDisposableListener(domNode, dom.EventType.KEY_DOWN, (e: KeyboardEvent) => listener(new StandardKeyboardEvent(e))));
	}

	protected p(domNode: HTMLElement, listener: (e: IKeyboardEvent) => void): void {
		this.q(dom.addDisposableListener(domNode, dom.EventType.KEY_UP, (e: KeyboardEvent) => listener(new StandardKeyboardEvent(e))));
	}

	protected u(domNode: HTMLElement, listener: (e: Event) => void): void {
		this.q(dom.addDisposableListener(domNode, dom.EventType.INPUT, listener));
	}

	protected y(domNode: HTMLElement, listener: (e: Event) => void): void {
		this.q(dom.addDisposableListener(domNode, dom.EventType.BLUR, listener));
	}

	protected B(domNode: HTMLElement, listener: (e: Event) => void): void {
		this.q(dom.addDisposableListener(domNode, dom.EventType.FOCUS, listener));
	}

	protected C(domNode: HTMLElement): IDisposable {
		return Gesture.ignoreTarget(domNode);
	}
}
